import { ChannelOrderEntry } from './types';

export const CHANNEL_ORDER_ALL_KEY = '__ALL__';

export const getChannelOrderForCurrentGroupId = (
    channelOrder: ChannelOrderEntry[] | undefined,
    groupId: string
): number | undefined => {
    if (!channelOrder?.length) return undefined;
    const entry = channelOrder.find((item) => item.groupId === groupId);
    return entry?.order;
};
